@for (group of resolvedGroups(); track group.key) {
    @if (!$first) {
        <span hisImage="HYPHEN" class="hyphen"></span>
    }
    <div class="treeActionGroup" [attr.data-group]="group.key">
    @for (action of group.actions; track action.identity.slotId) {
            @if (entireTemplateOverrideMap().get(action.identity.id); as tplOverride) {
                <ng-container
                    [ngTemplateOutlet]="tplOverride"
                    [ngTemplateOutletContext]="{ $implicit: action }">
                </ng-container>
            } @else if (action.state.rendered()) {
                @if (action.state.visible()) {
                    @if (templateOverrideMap().get(action.identity.id); as tplOverride) {
                        <ng-container
                            [ngTemplateOutlet]="tplOverride"
                            [ngTemplateOutletContext]="{ $implicit: action }">
                        </ng-container>
                    }
                    @else if (action.routeAction) {
                        <a  [class]="action.presentation.cssClass"
                            [class.disabled]="action.state.disabled()"
                            [attr.data-slot]="action.identity.slotId"
                            [attr.data-uid]="action.identity.elementUid"
                            [routerLink]="action.state.disabled() ? null : action.routeAction"
                            [title]="action.presentation.title | hisUi: action.presentation.label">
                            <span [hisImage]="action.presentation.icon"></span>
                        </a>
                    } @else {
                        <button [class]="action.presentation.cssClass"
                            [disabled]="action.state.disabled()"
                            [attr.aria-label]="action.presentation.title | hisUi: action.presentation.label"
                            [attr.data-slot]="action.identity.slotId"
                            [attr.data-uid]="action.identity.elementUid"
                            [title]="action.presentation.title | hisUi: action.presentation.label"
                            (click)="onActionClick(action, $event)">
                            <span [hisImage]="action.presentation.icon"></span>
                        </button>
                    }
                } @else {
                    <span hisImage="spacer" class="treeAction"></span>
                }
            }
        }
    </div>
}
